// extracted by mini-css-extract-plugin
module.exports = {"featuredLink":"featured-link_featuredLink__urRH6","container":"featured-link_container____vFS"};